<template>
  <nav
    v-if="user"
    class="topbar navbar navbar-light p-2 border-bottom"
  >
    <div class="container-fluid p-0">
      <div class="btn-group">
        <router-link
          :to="{name: 'home'}"
          class="btn btn-breadcrumb"
        >
          <i class="fa fa-home" />
        </router-link>
        <Breadcrumb />
      </div>

      <div class="dropleft">
        <button
          id="dropdownMenuButton"
          class="btn dropdown-toggle p-0 text-uppercase font-custom"
          type="button"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ user.login }}
          <i class="fa fa-user ms-1" />
        </button>
        <ul class="dropdown-menu dropdown-menu-end font-custom text-uppercase" aria-labelledby="dropdownMenuButton">
          <li>
            <a
            style="display:none !important"
            href="/user/changepassword"
            class="dropdown-item"
            >
              {{ $t('button.changePassword') }} <sup style="color:Red"><b>(Old)</b></sup>
            </a>
            <router-link
              :to="{ name: 'password-change' }"
              class="dropdown-item"
            >
              {{ $t('button.changePassword') }}
            </router-link>
          </li>
          <div class="dropdown-divider" />
          <li>
            <router-link
              :to="{ name: 'logout' }"
              class="dropdown-item"
            >
              {{ $t('button.logout') }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Breadcrumb from '@/components/BreadcrumbComponent.vue'

export default {
  components: {
    Breadcrumb
  },

  data () {
    return {
      user: JSON.parse(sessionStorage.getItem('user'))
    }
  }
}
</script>

<style lang="scss">
.topbar {
  height: 50px;

  .btn-breadcrumb {
    color: $shade-darkest;

    &:hover {
      text-decoration: none;
      color: $accent-primary;
    }
  }

  a {
    color: $shade-darker;
    text-decoration: none;
  }

}
</style>
